module.exports = __webpack_public_path__ + "static/media/arrow-right.7d1fa7f0.svg";